import { ILaya } from "../../../ILaya";
import { Point } from "../../maths/Point";
import { Rectangle } from "../../maths/Rectangle";
import { GButton } from "../GButton";
import { LayoutType, StretchMode } from "../Const";
import { UIConfig2 } from "../UIConfig";
import { Layout } from "./Layout";
import { UIEvent } from "../UIEvent";
export class ListLayout extends Layout {
    constructor() {
        super(...arguments);
        this._lineItemCnt = 0;
        this._numItems = 0;
        this._itemSize = new Point();
        this._firstIndex = 0;
        this._changed = 0;
        this._itemInfoVer = 0;
    }
    get numItems() {
        if (this._virtual)
            return this._numItems;
        else
            return this._owner.children.length;
    }
    set numItems(value) {
        if (this._virtual) {
            if (this._owner.itemRenderer == null)
                throw new Error("set itemRenderer first!");
            this._numItems = value;
            if (this._loop)
                this._realNumItems = this._numItems * 6;
            else
                this._realNumItems = this._numItems;
            let oldCount = this._items.length;
            if (this._realNumItems > oldCount) {
                for (let i = oldCount; i < this._realNumItems; i++) {
                    let ii = { width: 0, height: 0, flag: 0 };
                    ii.width = this._itemSize.x;
                    ii.height = this._itemSize.y;
                    this._items.push(ii);
                }
            }
            else {
                for (let i = this._realNumItems; i < oldCount; i++)
                    this._items[i].selected = false;
            }
            if (this._changed !== 0)
                ILaya.timer.clearCallLater(this, this._refreshVirtualList);
            this._refreshVirtualList();
        }
        else {
            let cnt = this._owner.children.length;
            if (value > cnt) {
                for (let i = cnt; i < value; i++) {
                    if (this._owner.itemProvider)
                        this._owner.addItemFromPool(this._owner.itemProvider(i));
                    else
                        this._owner.addItemFromPool();
                }
            }
            else {
                this._owner.removeChildrenToPool(value, cnt);
            }
            if (this._owner.itemRenderer) {
                for (let i = 0; i < value; i++)
                    this._owner.itemRenderer(i, this._owner.getChildAt(i));
            }
        }
    }
    get itemSize() {
        return this._itemSize;
    }
    set itemSize(value) {
        this._itemSize.setTo(value.x, value.y);
        if (this._virtual) {
            if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX)
                this._owner.scroller.step = this._itemSize.y;
            else
                this._owner.scroller.step = this._itemSize.x;
            this._changed = 2;
            ILaya.timer.callLater(this, this._refreshVirtualList);
        }
    }
    _setVirtual(loop) {
        if (this._virtual)
            return;
        this._virtual = true;
        this._loop = loop;
        this._items = [];
        this._itemSizes = [];
        this._owner.removeChildrenToPool();
        if (this._itemSize.x === 0 && this._itemSize.y === 0) {
            let obj = this._owner.getFromPool();
            if (obj == null) {
                throw new Error("Virtual List must have a default list item resource.");
            }
            else {
                this._itemSize.x = obj.width;
                this._itemSize.y = obj.height;
            }
            this._owner.returnToPool(obj);
        }
        this._owner.itemPool.clear();
        if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
            this._owner.scroller.step = this._itemSize.y;
            if (this._loop)
                this._owner.scroller._loop = 2;
        }
        else {
            this._owner.scroller.step = this._itemSize.x;
            if (this._loop)
                this._owner.scroller._loop = 1;
        }
        this._owner.on(UIEvent.Scroll, this, this._scrolled);
        this._changed = 2;
        ILaya.timer.callLater(this, this._refreshVirtualList);
    }
    childIndexToItemIndex(index) {
        if (!this._virtual)
            return index;
        if (this._pageMode) {
            for (let i = this._firstIndex; i < this._realNumItems; i++) {
                if (this._items[i].obj) {
                    index--;
                    if (index < 0)
                        return i;
                }
            }
            return index;
        }
        else {
            index += this._firstIndex;
            if (this._loop && this._numItems > 0)
                index = index % this._numItems;
            return index;
        }
    }
    itemIndexToChildIndex(index) {
        if (!this._virtual)
            return index;
        if (this._pageMode) {
            return this._owner.getChildIndex(this._items[index].obj);
        }
        else {
            if (this._loop && this._numItems > 0) {
                let j = this._firstIndex % this._numItems;
                if (index >= j)
                    index = index - j;
                else
                    index = this._numItems - j + index;
            }
            else
                index -= this._firstIndex;
            return index;
        }
    }
    shouldSnapToNext(dir, delta, size) {
        return dir < 0 && delta > UIConfig2.defaultScrollSnappingThreshold * size
            || dir > 0 && delta > (1 - UIConfig2.defaultScrollSnappingThreshold) * size
            || dir === 0 && delta > size / 2;
    }
    getSnappingPosition(xValue, yValue, xDir, yDir, resultPoint) {
        if (this._virtual) {
            if (!resultPoint)
                resultPoint = new Point();
            if (this._type === LayoutType.SingleColumn || (this._pageMode ? this._type === LayoutType.FlowY : this._type === LayoutType.FlowX)) {
                let saved = yValue;
                s_n = yValue;
                let index = this.getIndexOnPos1(false);
                yValue = s_n;
                if (index < this._items.length && index < this._realNumItems) {
                    let size = this._items[index].height;
                    if (this.shouldSnapToNext(yDir, saved - yValue, size))
                        yValue += size + this._rowGap;
                }
            }
            else {
                let saved = xValue;
                s_n = xValue;
                let index = this.getIndexOnPos2(false);
                xValue = s_n;
                if (index < this._items.length && index < this._realNumItems) {
                    let size = this._items[index].width;
                    if (this.shouldSnapToNext(xDir, saved - xValue, size))
                        xValue += size + this._columnGap;
                }
            }
            resultPoint.x = xValue;
            resultPoint.y = yValue;
            return resultPoint;
        }
        else
            return super.getSnappingPosition(xValue, yValue, xDir, yDir, resultPoint);
    }
    getRectByItemIndex(index) {
        if (!this._virtual || this._numItems === 0)
            return new Rectangle();
        this._checkVirtualList();
        if (index >= this._items.length)
            throw new Error("Invalid child index: " + index + ">" + this._items.length);
        if (this._loop)
            index = Math.floor(this._firstIndex / this._numItems) * this._numItems + index;
        let rect;
        let ii = this._items[index];
        let pos = 0;
        if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
            for (let i = this._lineItemCnt - 1; i < index; i += this._lineItemCnt)
                pos += this._items[i].height + this._rowGap;
            rect = new Rectangle(0, pos, this._itemSize.x, ii.height);
        }
        else {
            for (let i = this._lineItemCnt - 1; i < index; i += this._lineItemCnt)
                pos += this._items[i].width + this._columnGap;
            rect = new Rectangle(pos, 0, ii.width, this._itemSize.y);
        }
        return rect;
    }
    setChangedFlag(reason) {
        super.setChangedFlag(reason);
        if (this._layoutChanged && reason == null && this._virtual) {
            this._changed = 2;
            ILaya.timer.callLater(this, this._refreshVirtualList);
        }
    }
    refresh(force) {
        if (!this._virtual)
            super.refresh(force);
    }
    _checkVirtualList() {
        if (this._changed !== 0) {
            this._refreshVirtualList();
            ILaya.timer.clearCallLater(this, this._refreshVirtualList);
        }
    }
    refreshVirtualList() {
        if (this._changed === 0)
            this._changed = 1;
        ILaya.timer.callLater(this, this._refreshVirtualList);
    }
    getColumns() {
        if (this._columns > 0)
            return this._columns;
        else
            return Math.max(1, Math.floor((this.viewWidth + this._columnGap) / (this._itemSize.x + this._columnGap)));
    }
    getRows() {
        if (this._rows > 0)
            return this._rows;
        else
            return Math.max(1, Math.floor((this.viewHeight + this._rowGap) / (this._itemSize.y + this._rowGap)));
    }
    _refreshVirtualList() {
        if (this._owner.destroyed)
            return;
        let layoutChanged = this._changed === 2;
        this._changed = 0;
        this._eventLocked = true;
        let vw = this.viewWidth;
        let vh = this.viewHeight;
        if (layoutChanged) {
            this._lineItemCnt = 1;
            this._lineItemCnt2 = 1;
            if (this._type === LayoutType.FlowX) {
                this._lineItemCnt = this.getColumns();
                if (this._pageMode)
                    this._lineItemCnt2 = this.getRows();
            }
            else if (this._type === LayoutType.FlowY) {
                this._lineItemCnt = this.getRows();
                if (this._pageMode)
                    this._lineItemCnt2 = this.getColumns();
            }
            this._itemSizes.length = 0;
            if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
                if (this._stretchX === StretchMode.Stretch) {
                    for (let i = 0; i < this._lineItemCnt; i++)
                        this._itemSizes[i] = this._itemSize.x;
                    this.handleStrecth(vw, this._lineItemCnt, this._columnGap, this.stretchParamsX, this._itemSizes);
                }
            }
            else {
                if (this._stretchY === StretchMode.Stretch) {
                    for (let i = 0; i < this._lineItemCnt; i++)
                        this._itemSizes[i] = this._itemSize.y;
                    this.handleStrecth(vh, this._lineItemCnt, this._rowGap, this.stretchParamsY, this._itemSizes);
                }
            }
        }
        let ch = 0, cw = 0;
        if (this._realNumItems > 0) {
            let len = Math.ceil(this._realNumItems / this._lineItemCnt) * this._lineItemCnt;
            let len2 = Math.min(this._lineItemCnt, this._realNumItems);
            if (this._pageMode) {
                let pageCount = Math.ceil(len / (this._lineItemCnt * this._lineItemCnt2));
                if (this._type === LayoutType.SingleRow || this._type === LayoutType.FlowX) {
                    cw = pageCount * vw;
                    ch = vh;
                }
                else {
                    cw = vw;
                    ch = pageCount * vh;
                }
            }
            else if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
                for (let i = 0; i < len; i += this._lineItemCnt)
                    ch += this._items[i].height + this._rowGap;
                if (ch > 0)
                    ch -= this._rowGap;
                if (this._stretchX === StretchMode.Stretch)
                    cw = vw;
                else {
                    for (let i = 0; i < len2; i++)
                        cw += this._items[i].width + this._columnGap;
                    if (cw > 0)
                        cw -= this._columnGap;
                }
            }
            else {
                for (let i = 0; i < len; i += this._lineItemCnt)
                    cw += this._items[i].width + this._columnGap;
                if (cw > 0)
                    cw -= this._columnGap;
                if (this._stretchY === StretchMode.Stretch)
                    ch = vh;
                else {
                    for (let i = 0; i < len2; i++)
                        ch += this._items[i].height + this._rowGap;
                    if (ch > 0)
                        ch -= this._rowGap;
                }
            }
            this._offsetX = 0;
            this._offsetY = 0;
            if (cw < vw) {
                if (this._align === 1)
                    this._offsetX = Math.floor((vw - cw) / 2);
                else if (this._align === 2)
                    this._offsetX = vw - cw;
                if (!this._owner.scroller)
                    this._offsetX += this._padding[3];
            }
            if (ch < vh) {
                if (this._valign === 1)
                    this._offsetY = Math.floor((vh - ch) / 2);
                else if (this._valign === 2)
                    this._offsetY = vh - ch;
                if (!this._owner.scroller)
                    this._offsetY += this._padding[0];
            }
        }
        this.setContentSize(cw, ch);
        this._eventLocked = false;
        this.handleScroll(true);
    }
    _scrolled() {
        this.handleScroll(false);
    }
    getIndexOnPos1(forceUpdate) {
        if (this._realNumItems < this._lineItemCnt) {
            s_n = 0;
            return 0;
        }
        if (this._owner.numChildren > 0 && !forceUpdate) {
            let pos2 = this._owner.getChildAt(0).top;
            if (pos2 > s_n) {
                for (let i = this._firstIndex - this._lineItemCnt; i >= 0; i -= this._lineItemCnt) {
                    pos2 -= (this._items[i].height + this._rowGap);
                    if (pos2 <= s_n) {
                        s_n = pos2;
                        return i;
                    }
                }
                s_n = 0;
                return 0;
            }
            else {
                for (let i = this._firstIndex; i < this._realNumItems; i += this._lineItemCnt) {
                    let pos3 = pos2 + this._items[i].height + this._rowGap;
                    if (pos3 > s_n) {
                        s_n = pos2;
                        return i;
                    }
                    pos2 = pos3;
                }
                s_n = pos2;
                return this._realNumItems - this._lineItemCnt;
            }
        }
        else {
            let pos2 = 0;
            for (let i = 0; i < this._realNumItems; i += this._lineItemCnt) {
                let pos3 = pos2 + this._items[i].height + this._rowGap;
                if (pos3 > s_n) {
                    s_n = pos2;
                    return i;
                }
                pos2 = pos3;
            }
            s_n = pos2;
            return this._realNumItems - this._lineItemCnt;
        }
    }
    getIndexOnPos2(forceUpdate) {
        if (this._realNumItems < this._lineItemCnt) {
            s_n = 0;
            return 0;
        }
        if (this._owner.numChildren > 0 && !forceUpdate) {
            let pos2 = this._owner.getChildAt(0).left;
            if (pos2 > s_n) {
                for (let i = this._firstIndex - this._lineItemCnt; i >= 0; i -= this._lineItemCnt) {
                    pos2 -= (this._items[i].width + this._columnGap);
                    if (pos2 <= s_n) {
                        s_n = pos2;
                        return i;
                    }
                }
                s_n = 0;
                return 0;
            }
            else {
                for (let i = this._firstIndex; i < this._realNumItems; i += this._lineItemCnt) {
                    let pos3 = pos2 + this._items[i].width + this._columnGap;
                    if (pos3 > s_n) {
                        s_n = pos2;
                        return i;
                    }
                    pos2 = pos3;
                }
                s_n = pos2;
                return this._realNumItems - this._lineItemCnt;
            }
        }
        else {
            let pos2 = 0;
            for (let i = 0; i < this._realNumItems; i += this._lineItemCnt) {
                let pos3 = pos2 + this._items[i].width + this._columnGap;
                if (pos3 > s_n) {
                    s_n = pos2;
                    return i;
                }
                pos2 = pos3;
            }
            s_n = pos2;
            return this._realNumItems - this._lineItemCnt;
        }
    }
    getIndexOnPos3(forceUpdate) {
        if (this._realNumItems < this._lineItemCnt) {
            s_n = 0;
            return 0;
        }
        let vw = this.viewWidth;
        let page = Math.floor(s_n / vw);
        let startIndex = page * (this._lineItemCnt * this._lineItemCnt2);
        let pos2 = page * vw;
        for (let i = 0; i < this._lineItemCnt; i++) {
            let pos3 = pos2 + this._items[startIndex + i].width + this._columnGap;
            if (pos3 > s_n) {
                s_n = pos2;
                return startIndex + i;
            }
            pos2 = pos3;
        }
        s_n = pos2;
        return startIndex + this._lineItemCnt - 1;
    }
    getIndexOnPos4(forceUpdate) {
        if (this._realNumItems < this._lineItemCnt) {
            s_n = 0;
            return 0;
        }
        let vh = this.viewHeight;
        let page = Math.floor(s_n / vh);
        let startIndex = page * (this._lineItemCnt * this._lineItemCnt2);
        let pos2 = page * vh;
        for (let i = 0; i < this._lineItemCnt; i++) {
            let pos3 = pos2 + this._items[startIndex + i].height + this._rowGap;
            if (pos3 > s_n) {
                s_n = pos2;
                return startIndex + i;
            }
            pos2 = pos3;
        }
        s_n = pos2;
        return startIndex + this._lineItemCnt - 1;
    }
    handleScroll(forceUpdate) {
        if (this._eventLocked)
            return;
        if (this._pageMode) {
            if (this._type === LayoutType.SingleRow || this._type === LayoutType.FlowX)
                this.handleScroll3(forceUpdate);
            else
                this.handleScroll4(forceUpdate);
        }
        else if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
            let enterCounter = 0;
            while (this.handleScroll1(forceUpdate)) {
                enterCounter++;
                forceUpdate = false;
                if (enterCounter > 20) {
                    console.log("list will never be <the> filled item renderer function always returns a different size.");
                    break;
                }
            }
        }
        else {
            let enterCounter = 0;
            while (this.handleScroll2(forceUpdate)) {
                enterCounter++;
                forceUpdate = false;
                if (enterCounter > 20) {
                    console.log("list will never be <the> filled item renderer function always returns a different size.");
                    break;
                }
            }
        }
        this._layoutChanged = false;
    }
    handleScroll1(forceUpdate) {
        let scroller = this._owner.scroller;
        let pos = scroller.scrollingPosY;
        let max = pos + scroller.viewHeight;
        let end = max === scroller.contentHeight;
        s_n = pos;
        let newFirstIndex = this.getIndexOnPos1(forceUpdate);
        pos = s_n;
        if (newFirstIndex === this._firstIndex && !forceUpdate)
            return false;
        let oldFirstIndex = this._firstIndex;
        this._firstIndex = newFirstIndex;
        let curIndex = newFirstIndex;
        let forward = oldFirstIndex > newFirstIndex;
        let childCount = this._owner.numChildren;
        let lastIndex = oldFirstIndex + childCount - 1;
        let reuseIndex = forward ? lastIndex : oldFirstIndex;
        let curX = 0, curY = pos;
        let needRender;
        let deltaSize = 0;
        let firstItemDeltaSize = 0;
        let pool = this._owner.itemPool;
        let url = pool.defaultRes.url;
        this._itemInfoVer++;
        while (curIndex < this._realNumItems && (end || curY < max)) {
            let ii = this._items[curIndex];
            if (ii.obj == null || forceUpdate) {
                if (this._owner.itemProvider) {
                    url = this._owner.itemProvider(curIndex % this._numItems);
                    if (!url)
                        url = pool.defaultRes.url;
                }
                if (ii.obj && ii.obj.url != url) {
                    if (ii.obj instanceof GButton)
                        ii.selected = ii.obj.selected;
                    this._owner.removeChildToPool(ii.obj);
                    ii.obj = null;
                }
            }
            if (ii.obj == null) {
                if (forward) {
                    for (let j = reuseIndex; j >= oldFirstIndex; j--) {
                        let ii2 = this._items[j];
                        if (ii2.obj && ii2.flag !== this._itemInfoVer && ii2.obj.url == url) {
                            if (ii2.obj instanceof GButton)
                                ii2.selected = ii2.obj.selected;
                            ii.obj = ii2.obj;
                            ii2.obj = null;
                            if (j === reuseIndex)
                                reuseIndex--;
                            break;
                        }
                    }
                }
                else {
                    for (let j = reuseIndex; j <= lastIndex; j++) {
                        let ii2 = this._items[j];
                        if (ii2.obj && ii2.flag !== this._itemInfoVer && ii2.obj.url == url) {
                            if (ii2.obj instanceof GButton)
                                ii2.selected = ii2.obj.selected;
                            ii.obj = ii2.obj;
                            ii2.obj = null;
                            if (j === reuseIndex)
                                reuseIndex++;
                            break;
                        }
                    }
                }
                if (ii.obj) {
                    this._owner.setChildIndex(ii.obj, forward ? curIndex - newFirstIndex : this._owner.numChildren);
                }
                else {
                    ii.obj = pool.take(url);
                    if (forward)
                        this._owner.addChildAt(ii.obj, curIndex - newFirstIndex);
                    else
                        this._owner.addChild(ii.obj);
                }
                if (ii.obj instanceof GButton)
                    ii.obj.selected = ii.selected;
                needRender = true;
            }
            else
                needRender = forceUpdate;
            if (needRender) {
                let k = curIndex % this._lineItemCnt;
                if (this._stretchX === StretchMode.Stretch)
                    ii.obj.size(this._itemSizes[k], ii.obj.height);
                this._owner.itemRenderer(curIndex % this._numItems, ii.obj);
                Layout.refreshAllLayouts(this._owner);
                if (k === 0) {
                    deltaSize += Math.ceil(ii.obj.height) - ii.height;
                    if (curIndex === newFirstIndex && oldFirstIndex > newFirstIndex) {
                        firstItemDeltaSize = Math.ceil(ii.obj.height) - ii.height;
                    }
                }
                ii.width = Math.ceil(ii.obj.width);
                ii.height = Math.ceil(ii.obj.height);
            }
            ii.flag = this._itemInfoVer;
            ii.obj.setLeftTop(this._offsetX + curX, curY);
            if (curIndex === newFirstIndex)
                max += ii.height;
            curX += ii.width + this._columnGap;
            if (curIndex % this._lineItemCnt === this._lineItemCnt - 1) {
                curX = 0;
                curY += ii.height + this._rowGap;
            }
            curIndex++;
        }
        for (let i = 0; i < childCount; i++) {
            let ii = this._items[oldFirstIndex + i];
            if (ii.flag !== this._itemInfoVer && ii.obj) {
                if (ii.obj instanceof GButton)
                    ii.selected = ii.obj.selected;
                this._owner.removeChildToPool(ii.obj);
                ii.obj = null;
            }
        }
        childCount = this._owner.children.length;
        let maxWidth = 0;
        for (let i = 0; i < childCount; i++) {
            let obj = this._items[newFirstIndex + i].obj;
            if (this._owner.children[i] != obj)
                this._owner.setChildIndex(obj, i);
            let w = obj.width;
            if (w > maxWidth)
                maxWidth = w;
        }
        let deltaWidth = 0;
        let checkOverflow;
        if (this._type === LayoutType.SingleColumn && (checkOverflow = scroller._shouldCheckOverflow()) !== 0) {
            let resize;
            if ((checkOverflow & 2) !== 0) {
                deltaWidth = maxWidth - scroller.contentWidth;
                resize = Math.abs(deltaWidth) >= 1;
            }
            if ((checkOverflow & 1) !== 0 && scroller.contentHeight < scroller.viewHeight && maxWidth <= scroller.viewWidth) {
                maxWidth = scroller.viewWidth + scroller.vScrollBar.width;
                resize = true;
            }
            if (resize) {
                for (let i = 0; i < childCount; i++) {
                    let obj = this._owner.children[i];
                    obj.width = maxWidth;
                }
            }
        }
        if (deltaWidth !== 0 || deltaSize !== 0 || firstItemDeltaSize !== 0)
            scroller._changeContentSizeOnScrolling(deltaWidth, deltaSize, 0, firstItemDeltaSize);
        if (curIndex > 0 && this._owner.numChildren > 0 && this._owner._$container.y <= 0 && this._owner.getChildAt(0).top > -this._owner._$container.y)
            return true;
        else
            return false;
    }
    handleScroll2(forceUpdate) {
        let pos = this._owner.scroller.scrollingPosX;
        let max = pos + this._owner.scroller.viewWidth;
        let end = max === this._owner.scroller.contentWidth;
        s_n = pos;
        let newFirstIndex = this.getIndexOnPos2(forceUpdate);
        pos = s_n;
        if (newFirstIndex === this._firstIndex && !forceUpdate)
            return false;
        let oldFirstIndex = this._firstIndex;
        this._firstIndex = newFirstIndex;
        let curIndex = newFirstIndex;
        let forward = oldFirstIndex > newFirstIndex;
        let childCount = this._owner.numChildren;
        let lastIndex = oldFirstIndex + childCount - 1;
        let reuseIndex = forward ? lastIndex : oldFirstIndex;
        let curX = pos, curY = 0;
        let needRender;
        let deltaSize = 0;
        let firstItemDeltaSize = 0;
        let pool = this._owner.itemPool;
        let url = pool.defaultRes.url;
        this._itemInfoVer++;
        while (curIndex < this._realNumItems && (end || curX < max)) {
            let ii = this._items[curIndex];
            if (ii.obj == null || forceUpdate) {
                if (this._owner.itemProvider) {
                    url = this._owner.itemProvider(curIndex % this._numItems);
                    if (!url)
                        url = pool.defaultRes.url;
                }
                if (ii.obj && ii.obj.url != url) {
                    if (ii.obj instanceof GButton)
                        ii.selected = ii.obj.selected;
                    this._owner.removeChildToPool(ii.obj);
                    ii.obj = null;
                }
            }
            if (ii.obj == null) {
                if (forward) {
                    for (let j = reuseIndex; j >= oldFirstIndex; j--) {
                        let ii2 = this._items[j];
                        if (ii2.obj && ii2.flag !== this._itemInfoVer && ii2.obj.url == url) {
                            if (ii2.obj instanceof GButton)
                                ii2.selected = ii2.obj.selected;
                            ii.obj = ii2.obj;
                            ii2.obj = null;
                            if (j === reuseIndex)
                                reuseIndex--;
                            break;
                        }
                    }
                }
                else {
                    for (let j = reuseIndex; j <= lastIndex; j++) {
                        let ii2 = this._items[j];
                        if (ii2.obj && ii2.flag !== this._itemInfoVer && ii2.obj.url == url) {
                            if (ii2.obj instanceof GButton)
                                ii2.selected = ii2.obj.selected;
                            ii.obj = ii2.obj;
                            ii2.obj = null;
                            if (j === reuseIndex)
                                reuseIndex++;
                            break;
                        }
                    }
                }
                if (ii.obj) {
                    this._owner.setChildIndex(ii.obj, forward ? curIndex - newFirstIndex : this._owner.numChildren);
                }
                else {
                    ii.obj = pool.take(url);
                    if (forward)
                        this._owner.addChildAt(ii.obj, curIndex - newFirstIndex);
                    else
                        this._owner.addChild(ii.obj);
                }
                if (ii.obj instanceof GButton)
                    ii.obj.selected = ii.selected;
                needRender = true;
            }
            else
                needRender = forceUpdate;
            if (needRender) {
                let k = curIndex % this._lineItemCnt;
                if (this._stretchY === StretchMode.Stretch)
                    ii.obj.size(ii.obj.width, this._itemSizes[k]);
                this._owner.itemRenderer(curIndex % this._numItems, ii.obj);
                Layout.refreshAllLayouts(this._owner);
                if (k == 0) {
                    deltaSize += Math.ceil(ii.obj.width) - ii.width;
                    if (curIndex === newFirstIndex && oldFirstIndex > newFirstIndex) {
                        firstItemDeltaSize = Math.ceil(ii.obj.width) - ii.width;
                    }
                }
                ii.width = Math.ceil(ii.obj.width);
                ii.height = Math.ceil(ii.obj.height);
            }
            ii.flag = this._itemInfoVer;
            ii.obj.setLeftTop(curX, this._offsetY + curY);
            if (curIndex === newFirstIndex)
                max += ii.width;
            curY += ii.height + this._rowGap;
            if (curIndex % this._lineItemCnt === this._lineItemCnt - 1) {
                curY = 0;
                curX += ii.width + this._columnGap;
            }
            curIndex++;
        }
        for (let i = 0; i < childCount; i++) {
            let ii = this._items[oldFirstIndex + i];
            if (ii.flag !== this._itemInfoVer && ii.obj) {
                if (ii.obj instanceof GButton)
                    ii.selected = ii.obj.selected;
                this._owner.removeChildToPool(ii.obj);
                ii.obj = null;
            }
        }
        childCount = this._owner.numChildren;
        for (let i = 0; i < childCount; i++) {
            let obj = this._items[newFirstIndex + i].obj;
            if (this._owner.children[i] != obj)
                this._owner.setChildIndex(obj, i);
        }
        if (deltaSize !== 0 || firstItemDeltaSize !== 0)
            this._owner.scroller._changeContentSizeOnScrolling(deltaSize, 0, firstItemDeltaSize, 0);
        if (curIndex > 0 && this._owner.numChildren > 0 && this._owner._$container.x <= 0 && this._owner.getChildAt(0).left > -this._owner._$container.x)
            return true;
        else
            return false;
    }
    handleScroll3(forceUpdate) {
        let pos = this._owner.scroller.scrollingPosX;
        s_n = pos;
        let newFirstIndex = this.getIndexOnPos3(forceUpdate);
        pos = s_n;
        if (newFirstIndex === this._firstIndex && !forceUpdate)
            return;
        let oldFirstIndex = this._firstIndex;
        this._firstIndex = newFirstIndex;
        let reuseIndex = oldFirstIndex;
        let virtualItemCount = this._items.length;
        let pageSize = this._lineItemCnt * this._lineItemCnt2;
        let startCol = newFirstIndex % this._lineItemCnt;
        let vw = this.viewWidth;
        let vh = this.viewHeight;
        let page = Math.floor(newFirstIndex / pageSize);
        let startIndex = page * pageSize;
        let lastIndex = startIndex + pageSize * 2;
        let needRender;
        let partWidth, partHeight;
        if (this._stretchX === StretchMode.Stretch || this._stretchY === StretchMode.Stretch) {
            if (this._lineItemCnt === this._columns)
                partWidth = (vw - this._columnGap * (this._lineItemCnt - 1)) / this._lineItemCnt;
            if (this._lineItemCnt2 === this._rows)
                partHeight = (vh - this._rowGap * (this._lineItemCnt2 - 1)) / this._lineItemCnt2;
        }
        let pool = this._owner.itemPool;
        let url = pool.defaultRes.url;
        this._itemInfoVer++;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let col = i % this._lineItemCnt;
            if (i - startIndex < pageSize) {
                if (col < startCol)
                    continue;
            }
            else {
                if (col > startCol)
                    continue;
            }
            this._items[i].flag = this._itemInfoVer;
        }
        let lastObj = null;
        let insertIndex = 0;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let ii = this._items[i];
            if (ii.flag !== this._itemInfoVer)
                continue;
            if (ii.obj == null) {
                while (reuseIndex < virtualItemCount) {
                    let ii2 = this._items[reuseIndex];
                    if (ii2.obj && ii2.flag !== this._itemInfoVer) {
                        if (ii2.obj instanceof GButton)
                            ii2.selected = ii2.obj.selected;
                        ii.obj = ii2.obj;
                        ii2.obj = null;
                        break;
                    }
                    reuseIndex++;
                }
                if (insertIndex === -1)
                    insertIndex = this._owner.getChildIndex(lastObj) + 1;
                if (ii.obj == null) {
                    if (this._owner.itemProvider) {
                        url = this._owner.itemProvider(i % this._numItems);
                        if (!url)
                            url = pool.defaultRes.url;
                    }
                    ii.obj = pool.take(url);
                    this._owner.addChildAt(ii.obj, insertIndex);
                }
                else {
                    insertIndex = this._owner.setChildIndexBefore(ii.obj, insertIndex);
                }
                insertIndex++;
                if (ii.obj instanceof GButton)
                    ii.obj.selected = ii.selected;
                needRender = true;
            }
            else {
                needRender = forceUpdate;
                insertIndex = -1;
                lastObj = ii.obj;
            }
            if (needRender) {
                if (partWidth != null || partHeight != null)
                    ii.obj.size(partWidth !== null && partWidth !== void 0 ? partWidth : ii.obj.width, partHeight !== null && partHeight !== void 0 ? partHeight : ii.obj.height);
                this._owner.itemRenderer(i % this._numItems, ii.obj);
                Layout.refreshAllLayouts(this._owner);
                ii.width = Math.ceil(ii.obj.width);
                ii.height = Math.ceil(ii.obj.height);
            }
        }
        let borderX = (startIndex / pageSize) * vw;
        let xx = borderX;
        let yy = 0;
        let lineHeight = 0;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let ii = this._items[i];
            if (ii.flag === this._itemInfoVer)
                ii.obj.setLeftTop(xx, yy);
            if (ii.height > lineHeight)
                lineHeight = ii.height;
            if (i % this._lineItemCnt === this._lineItemCnt - 1) {
                xx = borderX;
                yy += lineHeight + this._rowGap;
                lineHeight = 0;
                if (i === startIndex + pageSize - 1) {
                    borderX += vw;
                    xx = borderX;
                    yy = 0;
                }
            }
            else
                xx += ii.width + this._columnGap;
        }
        for (let i = reuseIndex; i < virtualItemCount; i++) {
            let ii = this._items[i];
            if (ii.flag !== this._itemInfoVer && ii.obj) {
                if (ii.obj instanceof GButton)
                    ii.selected = ii.obj.selected;
                this._owner.removeChildToPool(ii.obj);
                ii.obj = null;
            }
        }
    }
    handleScroll4(forceUpdate) {
        let pos = this._owner.scroller.scrollingPosY;
        s_n = pos;
        let newFirstIndex = this.getIndexOnPos4(forceUpdate);
        pos = s_n;
        if (newFirstIndex === this._firstIndex && !forceUpdate)
            return;
        let oldFirstIndex = this._firstIndex;
        this._firstIndex = newFirstIndex;
        let reuseIndex = oldFirstIndex;
        let virtualItemCount = this._items.length;
        let pageSize = this._lineItemCnt * this._lineItemCnt2;
        let startRow = newFirstIndex % this._lineItemCnt;
        let vw = this.viewWidth;
        let vh = this.viewHeight;
        let page = Math.floor(newFirstIndex / pageSize);
        let startIndex = page * pageSize;
        let lastIndex = startIndex + pageSize * 2;
        let needRender;
        let partWidth, partHeight;
        if (this._stretchX === StretchMode.Stretch || this._stretchY === StretchMode.Stretch) {
            if (this._lineItemCnt2 === this._columns)
                partWidth = (vw - this._columnGap * (this._lineItemCnt2 - 1)) / this._lineItemCnt2;
            if (this._lineItemCnt === this._rows)
                partHeight = (vh - this._rowGap * (this._lineItemCnt - 1)) / this._lineItemCnt;
        }
        let pool = this._owner.itemPool;
        let url = pool.defaultRes.url;
        this._itemInfoVer++;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let col = i % this._lineItemCnt;
            if (i - startIndex < pageSize) {
                if (col < startRow)
                    continue;
            }
            else {
                if (col > startRow)
                    continue;
            }
            let ii = this._items[i];
            ii.flag = this._itemInfoVer;
        }
        let lastObj = null;
        let insertIndex = 0;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let ii = this._items[i];
            if (ii.flag !== this._itemInfoVer)
                continue;
            if (ii.obj == null) {
                while (reuseIndex < virtualItemCount) {
                    let ii2 = this._items[reuseIndex];
                    if (ii2.obj && ii2.flag !== this._itemInfoVer) {
                        if (ii2.obj instanceof GButton)
                            ii2.selected = ii2.obj.selected;
                        ii.obj = ii2.obj;
                        ii2.obj = null;
                        break;
                    }
                    reuseIndex++;
                }
                if (insertIndex === -1)
                    insertIndex = this._owner.getChildIndex(lastObj) + 1;
                if (ii.obj == null) {
                    if (this._owner.itemProvider) {
                        url = this._owner.itemProvider(i % this._numItems);
                        if (!url)
                            url = pool.defaultRes.url;
                    }
                    ii.obj = pool.take(url);
                    this._owner.addChildAt(ii.obj, insertIndex);
                }
                else {
                    insertIndex = this._owner.setChildIndexBefore(ii.obj, insertIndex);
                }
                insertIndex++;
                if (ii.obj instanceof GButton)
                    ii.obj.selected = ii.selected;
                needRender = true;
            }
            else {
                needRender = forceUpdate;
                insertIndex = -1;
                lastObj = ii.obj;
            }
            if (needRender) {
                if (partWidth != null || partHeight != null)
                    ii.obj.size(partWidth !== null && partWidth !== void 0 ? partWidth : ii.obj.width, partHeight !== null && partHeight !== void 0 ? partHeight : ii.obj.height);
                this._owner.itemRenderer(i % this._numItems, ii.obj);
                Layout.refreshAllLayouts(this._owner);
                ii.width = Math.ceil(ii.obj.width);
                ii.height = Math.ceil(ii.obj.height);
            }
        }
        let borderY = (startIndex / pageSize) * vh;
        let xx = 0;
        let yy = borderY;
        let lineWidth = 0;
        for (let i = startIndex; i < lastIndex; i++) {
            if (i >= this._realNumItems)
                continue;
            let ii = this._items[i];
            if (ii.flag === this._itemInfoVer)
                ii.obj.setLeftTop(xx, yy);
            if (ii.width > lineWidth)
                lineWidth = ii.width;
            if (i % this._lineItemCnt === this._lineItemCnt - 1) {
                xx += lineWidth + this._columnGap;
                yy = borderY;
                lineWidth = 0;
                if (i === startIndex + pageSize - 1) {
                    borderY += vh;
                    xx = 0;
                    yy = borderY;
                }
            }
            else
                yy += ii.height + this._rowGap;
        }
        for (let i = reuseIndex; i < virtualItemCount; i++) {
            let ii = this._items[i];
            if (ii.flag !== this._itemInfoVer && ii.obj) {
                if (ii.obj instanceof GButton)
                    ii.selected = ii.obj.selected;
                this._owner.removeChildToPool(ii.obj);
                ii.obj = null;
            }
        }
    }
}
let s_n = 0;
